import React from "react";

export const AnnouncementIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 2.95833V17.0417L7.5 13.75H3.33333V6.25H7.5L11.25 2.95833Z"
      stroke="#433358"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5833 6.25C15.1532 6.98303 15.4716 7.88044 15.4901 8.81002C15.5086 9.73959 15.2262 10.6514 14.6833 11.4167"
      stroke="#433358"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckboxIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.5"
      y="2.5"
      width="15"
      height="15"
      rx="2"
      stroke="#433358"
      strokeWidth="1.5"
    />
    <path
      d="M6.25 10L8.75 12.5L13.75 7.5"
      stroke="#433358"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClockIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10"
      cy="10"
      r="8.33333"
      stroke="#433358"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 5V10L13.3333 11.6667"
      stroke="#433358"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RocketIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8501 2.33018L16.1718 2.37685C16.6718 2.45602 17.2317 2.58852 17.5759 2.93268C17.9209 3.27768 18.0534 3.83768 18.1326 4.33768L18.1792 4.65852C18.2843 5.41685 18.3118 6.41102 18.1326 7.51435C17.7793 9.69185 16.6201 12.2893 13.7093 14.3018C13.6958 14.4506 13.6911 14.6 13.6951 14.7493L13.7093 15.2018C13.7176 15.5035 13.7126 15.8043 13.6293 16.0935C13.4709 16.6435 12.9068 17.006 12.3793 17.266L12.1209 17.3885L11.7876 17.5352L11.5601 17.6268C10.9709 17.8518 10.2601 18.0093 9.79509 17.5435C9.58425 17.3327 9.48675 17.046 9.40842 16.7593L9.37009 16.616C9.23675 16.1102 9.08592 15.6077 8.89758 15.121C8.84555 15.1842 8.79049 15.2448 8.73258 15.3027C8.27842 15.756 7.66259 15.9843 7.04675 16.161L6.63759 16.2735L6.22925 16.3818L5.83092 16.4818L5.47092 16.5652L5.04009 16.6568L4.77092 16.7093C4.63664 16.7344 4.49829 16.7264 4.36781 16.686C4.23733 16.6455 4.11867 16.5739 4.02209 16.4773C3.9255 16.3808 3.8539 16.2621 3.81347 16.1316C3.77305 16.0011 3.76502 15.8628 3.79009 15.7285L3.88259 15.2693L3.99009 14.7877L4.09342 14.3627L4.28092 13.6585C4.46675 12.9752 4.69259 12.271 5.19759 11.7668L5.28009 11.6877L4.64425 11.4593L4.00509 11.2393C3.63092 11.116 3.23759 10.986 2.96592 10.7143C2.46925 10.2177 2.68009 9.44268 2.92759 8.83352L3.06592 8.51102L3.18009 8.26018C3.44425 7.69852 3.81925 7.05185 4.41592 6.88018C4.70509 6.79685 5.00509 6.79185 5.30759 6.79935L5.76009 6.81435C5.91009 6.81685 6.06009 6.81435 6.20759 6.80018C8.21925 3.88935 10.8176 2.73018 12.9951 2.37685C13.9393 2.22119 14.9013 2.20546 15.8501 2.33018ZM13.2618 4.02185C11.4301 4.31935 9.20425 5.30018 7.46759 7.91268C7.25675 8.22935 6.90092 8.38018 6.53842 8.43768C6.33342 8.47102 6.12675 8.47935 5.91925 8.47935L5.29675 8.47018C5.19342 8.47018 5.08925 8.47018 4.98592 8.47518C4.73259 8.81185 4.55592 9.21185 4.42342 9.60935L5.67342 10.0635L6.18759 10.2577C7.12758 10.626 8.03759 11.0718 8.73759 11.7718C9.91675 12.951 10.5159 14.4935 10.9493 16.0693C11.3293 15.936 11.7109 15.766 12.0343 15.5235L12.0393 15.2127L12.0301 14.591C12.0301 14.3843 12.0384 14.1777 12.0718 13.971C12.1284 13.6085 12.2801 13.2527 12.5968 13.0418C15.2093 11.3052 16.1901 9.07935 16.4876 7.24768C16.6376 6.32268 16.6126 5.49602 16.5284 4.88685C16.4961 4.63412 16.4423 4.3846 16.3676 4.14102C16.124 4.06657 15.8745 4.01304 15.6218 3.98102C14.8373 3.87932 14.0421 3.89253 13.2618 4.02185ZM6.37509 12.9452C6.08342 13.2977 5.94759 13.7602 5.83842 14.2185L5.74842 14.6085L5.70259 14.7968L6.28092 14.661C6.73925 14.5527 7.20259 14.4152 7.55425 14.1235C7.71051 13.9671 7.79825 13.7551 7.79817 13.5341C7.79809 13.313 7.7102 13.101 7.55384 12.9448C7.39747 12.7885 7.18543 12.7008 6.96437 12.7008C6.74332 12.7009 6.53134 12.7888 6.37509 12.9452ZM11.0893 7.05352C11.244 6.89872 11.4277 6.77592 11.6299 6.69212C11.8321 6.60833 12.0488 6.56518 12.2677 6.56514C12.4866 6.5651 12.7033 6.60817 12.9056 6.6919C13.1078 6.77562 13.2915 6.89836 13.4463 7.0531C13.6011 7.20784 13.7239 7.39155 13.8077 7.59375C13.8915 7.79595 13.9347 8.01268 13.9347 8.23155C13.9347 8.45043 13.8917 8.66717 13.808 8.8694C13.7242 9.07163 13.6015 9.25539 13.4468 9.41018C13.1341 9.72281 12.7101 9.89844 12.268 9.89844C11.8259 9.89844 11.4019 9.72281 11.0893 9.41018C10.7766 9.09756 10.601 8.67355 10.601 8.23143C10.601 7.78932 10.7766 7.36531 11.0893 7.05268V7.05352Z"
      fill="#0C001C"
    />
  </svg>
);
